// Resolves the option that keyboard navigation has focused, given the current
// options list and focus index. Returns undefined when the focus index does not
// point at a real option — for example when it went stale after the options were
// replaced by a search — so the caller can treat "no focused option" as a no-op
// instead of crashing on an out-of-range index.
export default function focusedOption(options, focusIndex) {
  if (focusIndex == null || !Array.isArray(options)) {
    return undefined
  }

  if (focusIndex < 0 || focusIndex >= options.length) {
    return undefined
  }

  return options[focusIndex]
}
